import './ProfileHeader.scss';

export interface ProfileHeaderProps {
  username: string;
  displayName?: string | null;
  avatar?: string | null;
  role?: string;
  followerCount?: number | null;
  followingCount?: number | null;
  joinLabel?: string | null;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const letters =
    parts.length >= 2 ? parts[0][0] + parts[1][0] : name.slice(0, 2);
  return letters.toUpperCase();
}

const count = (n?: number | null): string =>
  typeof n === 'number' ? String(n) : '—';

export function ProfileHeader({
  username,
  displayName,
  avatar,
  role,
  followerCount,
  followingCount,
  joinLabel,
}: ProfileHeaderProps) {
  const title = displayName?.trim() || `@${username}`;
  const hasDisplayName = Boolean(displayName?.trim());
  return (
    <div className="profile-header">
      <div className="profile-header__avatar" aria-hidden="true">
        {avatar ? (
          <img src={avatar} alt="" />
        ) : (
          <span>{initials(displayName || username)}</span>
        )}
      </div>
      <div className="profile-header__identity">
        <h1 className="profile-header__name" aria-label={title}>
          {title}
          {role ? <span className="profile-header__role">{role}</span> : null}
        </h1>
        {hasDisplayName ? (
          <div className="profile-header__handle">@{username}</div>
        ) : null}
        <div className="profile-header__meta">
          <span>
            <b>{count(followerCount)}</b> followers
          </span>
          <span>
            <b>{count(followingCount)}</b> following
          </span>
          {joinLabel ? <span>Joined {joinLabel}</span> : null}
        </div>
      </div>
    </div>
  );
}
